













import Vue from "vue";
import Dialog from "@/components/dialogs/Dialog.vue";
import Notification from "@/components/notifications/Notification.vue";
import Alert from "@/components/alerts/Alert.vue";
import NotificationGDPR from "./components/vue-components/NotificationGDPR.vue";
import Intercom from "@intercom/messenger-js-sdk";

export default Vue.extend({
  name: "App",
  components: {
    Dialog,
    Notification,
    Alert,
    NotificationGDPR
  }
});

if (process.env.NODE_ENV === "production" && typeof window !== "undefined") {
  Intercom({
    app_id: "b0sii903"
  });
}
